import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { isNil } from 'lodash';

@Component({
  selector: 'app-description-snackbar',
  templateUrl: './description-snackbar.component.html',
  styleUrls: ['./description-snackbar.component.scss'],
})
export class DescriptionSnackbarComponent {
  text = '';
  isIconDisplayed = true;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    this.text = this.data.text;
    this.isIconDisplayed = !isNil(this.data.isIconDisplayed) ? this.data.isIconDisplayed : true;
  }
}
